import React from 'react';
import { Box, Typography } from '@mui/material';
import ecoLogo from '../../assets/eco_logo.png';
import { authColors, fontStack } from './authStyles';

// Badge logo (cadre arrondi + ombre) + libellé « Ecowatch 360 »
const BrandLogo = ({
  iconSize = 48,
  showText = true,
  fontSize = '20px',
  textColor = authColors.textPrimary,
  vertical = false,
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row',
      alignItems: 'center',
      gap: vertical ? '10px' : '14px',
    }}
  >
    <Box
      sx={{
        width: iconSize,
        height: iconSize,
        borderRadius: iconSize <= 40 ? '12px' : '14px',
        overflow: 'hidden',
        flexShrink: 0,
        boxShadow: '0 8px 24px rgba(52, 211, 153, 0.33)',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      }}
    >
      <Box
        component="img"
        src={ecoLogo}
        alt="Ecowatch"
        sx={{
          width: iconSize * 1.2,
          height: 'auto',
          objectFit: 'cover',
          objectPosition: 'top center',
        }}
      />
    </Box>
    {showText && (
      <Typography
        sx={{
          color: textColor,
          fontSize,
          fontWeight: 700,
          letterSpacing: '0.2px',
          fontFamily: fontStack,
          whiteSpace: 'nowrap',
        }}
      >
        Ecowatch 360
      </Typography>
    )}
  </Box>
);

export default BrandLogo;
